<template>
  <div class="refund-detail">
    <div id="TopTabs" class="content">
      <SearchNav />

      <div class="page">
        <div class="refund-detail-content">

          <div class="page-nav-wrapper">
            <span @click="goHome" class="pointer nav-item">我的商城</span>
            <span @click="goRefundList" class="pointer nav-item">&nbsp;/&nbsp;退款/售后管理</span>
            <span class="nav-item nav-active">&nbsp;/&nbsp;退款/售后详情</span>
          </div>

          <div class="content">
            <div class="order-info">
              <div>
                退款编号：
                <span>{{ info.refundOrderSn }}</span>
              </div>
              <div>
                归属订单编号：
                <span>{{ info.orderSn }}</span>
              </div>
            </div>
            <detailMessage :info="info"></detailMessage>
            <detailSKU :info="info"></detailSKU>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SearchNav from '@/components/SearchNav'
import detailMessage from './components/detailMessage'
import cloneDeep from 'lodash/cloneDeep'
import detailSKU from './components/detailSKU'
import * as api from '@/services'
import { fen2yuanAddZeroes } from '@/utils/calculate'

const dfDetail = {
  payType: null,
  orderSn: null,
  refundOrderSn: null,
  applyTime: null,
  returnType: null,
  applyRefundAmount: '',
  refundShowStatus: '',
  refundReasonId: '',
  refundReason: '',
  countdown: '',
  supplyRefundReason: '',
  closeReasonId: '',
  itemInfos: [],
  refundReasons: [],
  refundBackInfo: {
    name: '',
    phone: '',
    address: ''
  },
  logisticsInfo: [],
  shopInfo: {
    shopId: null,
    shopLogo: null,
    shopName: null,
    shopPhone: null
  },
  refundSuccessAmount: null,
  refundAccountInfo: {
    payee: null,
    openingBank: null,
    bankAccount: null,
    bankUnionNumber: null,
    receivingAccountArea: null,
  },
  pictures: [],
  customerName: null
}

export default {
  components: {
    detailMessage,
    detailSKU,
    SearchNav
  },
  data() {
    return {
      refundOrderSn: null,
      info: cloneDeep(dfDetail)
    }
  },
  mounted() {
    this.refundOrderSn = this.$route.query.refundOrderSn
    this.init()
  },
  methods: {
    init() {
      this.getData()
    },
    async getData() {
      const data = await api.refund.queryRefundDetail({
        refundOrderSn: this.refundOrderSn
      })

      const newItemInfos = data.itemInfos && data.itemInfos.map(item => ({
        ...item,
        realPriceYuan: fen2yuanAddZeroes(item.realPrice),
        unitPriceYuan: fen2yuanAddZeroes(item.unitPrice),
        refundPayAmountYuan: fen2yuanAddZeroes(item.refundPayAmount),
      }))
      this.info = {
        ...this.info,
        ...data,
        itemInfos: newItemInfos,
        applyRefundAmountYuan: fen2yuanAddZeroes(data.applyRefundAmount),
      }
    },

    goHome() {
      this.$router.push('/personalCenter/index');
    },
    goRefundList() {
      this.$router.push('/refundList');
    }
  }
}
</script>
<style lang="scss" scoped>
.page {
  padding: 16px;
}
.page-nav-wrapper {
  font-size: 12px;
  font-weight: 400;
  padding-top: 12px;
  //background-color: #f6f6f6;
  padding-bottom: 12px;
  .nav-item {
    color: #333333;
    line-height: 20px;
  }
  .nav-active {
    color: #888888;
    line-height: 20px;
  }
}
.refund-detail-content {
  background: #fff;
  .title {
    padding: 16px;
    font-size: 16px;
    font-weight: 500;
    color: #262626;
    line-height: 24px;
    border-bottom: 1px solid #e6e6e6;
  }
  .content {
    //padding: 16px;
    .order-info {
      display: flex;
      padding-top: 6px;
      margin-bottom: 12px;
      div {
        color: #8c8c8c;
        font-size: 12px;
        margin-right: 16px;
        span {
          color: #333;
        }
      }
    }
  }
}
</style>
